import React, { useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import {
  FiBell, FiEdit2, FiTrash2, FiSend, FiPlus, FiX, FiLink, FiCheck, FiChevronDown,
} from "react-icons/fi";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const REDIRECT_ROUTES = [
  "/ANNOUNCEMENT", "/home", "/chat", "/refer", "/profile", "/settings",
  "/leaderboard", "/creator-hub", "/creator-profile", "/content-info",
  "/information", "/edit-profile", "/kyc-verification", "/kyc-help",
  "/login", "/signup", "/verification", "/forgot-password", "/reset-password",
  "/change-password", "/strike", "/thankyou", "/update-app",
];

const COUNTRIES = [
  { code: "AF", name: "Afghanistan" }, { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" }, { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" }, { code: "AG", name: "Antigua and Barbuda" },
  { code: "AR", name: "Argentina" }, { code: "AM", name: "Armenia" },
  { code: "AU", name: "Australia" }, { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" }, { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" }, { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" }, { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" }, { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" }, { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" }, { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" }, { code: "BR", name: "Brazil" },
  { code: "BN", name: "Brunei" }, { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" }, { code: "BI", name: "Burundi" },
  { code: "CV", name: "Cabo Verde" }, { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" }, { code: "CA", name: "Canada" },
  { code: "CF", name: "Central African Republic" }, { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" }, { code: "CN", name: "China" },
  { code: "CO", name: "Colombia" }, { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" }, { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croatia" }, { code: "CU", name: "Cuba" },
  { code: "CY", name: "Cyprus" }, { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" }, { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" }, { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" }, { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" }, { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" }, { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" }, { code: "ET", name: "Ethiopia" },
  { code: "FJ", name: "Fiji" }, { code: "FI", name: "Finland" },
  { code: "FR", name: "France" }, { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" }, { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" }, { code: "GH", name: "Ghana" },
  { code: "GR", name: "Greece" }, { code: "GD", name: "Grenada" },
  { code: "GT", name: "Guatemala" }, { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" }, { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" }, { code: "HN", name: "Honduras" },
  { code: "HU", name: "Hungary" }, { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" }, { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" }, { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" }, { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" }, { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" }, { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" }, { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" }, { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" }, { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" }, { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" }, { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" }, { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" }, { code: "LU", name: "Luxembourg" },
  { code: "MG", name: "Madagascar" }, { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" }, { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" }, { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" }, { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" }, { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" }, { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" }, { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" }, { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" }, { code: "MM", name: "Myanmar" },
  { code: "NA", name: "Namibia" }, { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" }, { code: "NL", name: "Netherlands" },
  { code: "NZ", name: "New Zealand" }, { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" }, { code: "NG", name: "Nigeria" },
  { code: "NO", name: "Norway" }, { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" }, { code: "PW", name: "Palau" },
  { code: "PA", name: "Panama" }, { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" }, { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" }, { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" }, { code: "QA", name: "Qatar" },
  { code: "RO", name: "Romania" }, { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" }, { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "LC", name: "Saint Lucia" }, { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "WS", name: "Samoa" }, { code: "SM", name: "San Marino" },
  { code: "ST", name: "Sao Tome and Principe" }, { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" }, { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" }, { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" }, { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" }, { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" }, { code: "ZA", name: "South Africa" },
  { code: "SS", name: "South Sudan" }, { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" }, { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" }, { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" }, { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" }, { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" }, { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" }, { code: "TG", name: "Togo" },
  { code: "TO", name: "Tonga" }, { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" }, { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" }, { code: "TV", name: "Tuvalu" },
  { code: "UG", name: "Uganda" }, { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" }, { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" }, { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" }, { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" }, { code: "VN", name: "Vietnam" },
  { code: "YE", name: "Yemen" }, { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

const NotificationPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [redirectRoute, setRedirectRoute] = useState("");
  const [targetDeviceTypes, setTargetDeviceTypes] = useState([]);
  const [targetCountries, setTargetCountries] = useState([]);
  const [countrySearch, setCountrySearch] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [sendingId, setSendingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const imageInputRef = useRef(null);
  const countryRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutside = (e) => {
      if (countryRef.current && !countryRef.current.contains(e.target)) {
        setCountryDropdownOpen(false);
        setCountrySearch("");
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/notification/list?page=${page}&limit=${limit}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (result.data) {
        setNotifications(result.data);
        setTotal(result.pagination?.total ?? result.total ?? 0);
      }
    } catch {
      toast.error("Failed to fetch notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const handleImageChange = (e) => {
    const file = e.target.files[0] || null;
    setImage(file);
    setImagePreview(file ? URL.createObjectURL(file) : null);
  };

  const handleCancel = () => {
    setTitle(""); setMessage(""); setImage(null);
    setImagePreview(null); setRedirectRoute(""); setEditId(null);
    setTargetDeviceTypes([]); setTargetCountries([]);
    setCountrySearch(""); setCountryDropdownOpen(false);
    if (imageInputRef.current) imageInputRef.current.value = "";
  };

  const toggleCountry = (code) => {
    setTargetCountries((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    );
  };

  const handleCreateOrUpdate = async () => {
    if (!title || !message) { toast.error("Title and message are required"); return; }
    if (targetDeviceTypes.length === 0) { toast.error("Please select at least one target device"); return; }
    setSubmitting(true);
    const token = localStorage.getItem("token");
    const url = editId ? `${baseUrl}/notification/edit/${editId}` : `${baseUrl}/notification/create`;
    const method = editId ? "PUT" : "POST";

    let body, headers = { Authorization: `Bearer ${token}` };
    if (image) {
      const fd = new FormData();
      fd.append("title", title); fd.append("message", message); fd.append("image", image);
      if (redirectRoute) fd.append("redirectRoute", redirectRoute);
      if (editId || targetDeviceTypes.length > 0) fd.append("targetDeviceTypes", JSON.stringify(targetDeviceTypes));
      if (editId || targetCountries.length > 0) fd.append("targetCountries", JSON.stringify(targetCountries));
      body = fd;
    } else {
      headers["Content-Type"] = "application/json";
      body = JSON.stringify({
        title, message,
        ...(redirectRoute && { redirectRoute }),
        ...(editId || targetDeviceTypes.length > 0 ? { targetDeviceTypes } : {}),
        ...(editId || targetCountries.length > 0 ? { targetCountries } : {}),
      });
    }

    try {
      const res = await fetch(url, { method, headers, body });
      const result = await res.json();
      const isSuccess = res.ok && result.success !== false && !result.error;
      if (isSuccess) {
        toast.success(editId ? "Updated successfully!" : "Created successfully!");
        handleCancel();
        await fetchNotifications();
      } else {
        toast.error(result.message || result.error || "Something went wrong");
      }
    } catch {
      toast.error("Server error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSend = async (id) => {
    setSendingId(id);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/notification/send-notification/${id}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (res.ok) toast.success("Notification sent!");
      else toast.error(result.message || "Failed to send.");
    } catch {
      toast.error("Error sending notification.");
    } finally {
      setSendingId(null);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    setDeletingId(id);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${baseUrl}/notification/delete/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (res.ok) { toast.success("Deleted successfully!"); await fetchNotifications(); }
      else toast.error(result.message || "Failed to delete.");
    } catch {
      toast.error("Error deleting notification.");
    } finally {
      setDeletingId(null);
    }
  };

  const filteredCountries = COUNTRIES.filter(
    (c) =>
      !targetCountries.includes(c.code) &&
      (c.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
        c.code.toLowerCase().includes(countrySearch.toLowerCase()))
  );

  const totalPages = Math.ceil(total / limit);

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Toaster position="top-right" />
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Navbar />
        <div className="p-5 sm:p-8 space-y-6">

          {/* Heading */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#ffffcc] flex items-center justify-center">
              <FiBell size={20} className="text-[#999900]" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Notifications</h2>
              <p className="text-sm text-gray-400 mt-0.5">Create and manage push notifications</p>
            </div>
          </div>

          {/* Form card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <h3 className="text-sm font-semibold text-gray-700 mb-5">
              {editId ? "Edit Notification" : "Create Notification"}
            </h3>
            <div className="space-y-4">

              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Title <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Notification title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#ffff00]"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-500 mb-1">
                  Message <span className="text-red-400">*</span>
                </label>
                <textarea
                  placeholder="Notification message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={4}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#ffff00] resize-none"
                />
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Banner Image <span className="text-gray-300">(optional)</span>
                  </label>
                  <input
                    ref={imageInputRef}
                    type="file"
                    accept=".jpg,.jpeg,.png,.webp"
                    onChange={handleImageChange}
                    className="w-full text-sm text-gray-500 border border-gray-200 rounded-lg px-3 py-2 file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:font-medium file:bg-[#ffffe0] file:text-[#999900] hover:file:bg-[#ffffcc]"
                  />
                  {imagePreview && (
                    <div className="mt-2 relative w-fit">
                      <img src={imagePreview} alt="preview" className="h-20 rounded-lg object-cover border" />
                      <button
                        onClick={() => { setImage(null); setImagePreview(null); if (imageInputRef.current) imageInputRef.current.value = ""; }}
                        className="absolute -top-1.5 -right-1.5 bg-red-500 text-white rounded-full p-0.5"
                      >
                        <FiX size={10} />
                      </button>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    <FiLink className="inline mr-1" size={11} />
                    Redirect Route <span className="text-gray-300">(optional)</span>
                  </label>
                  <select
                    value={redirectRoute}
                    onChange={(e) => setRedirectRoute(e.target.value)}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#ffff00]"
                  >
                    <option value="">-- Select route --</option>
                    {REDIRECT_ROUTES.map((route) => (
                      <option key={route} value={route}>{route}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">

                {/* Target Device Types */}
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1.5">
                    Target Devices <span className="text-red-400">*</span>
                  </label>
                  <div className="flex gap-2">
                    {["Android", "IOS"].map((device) => (
                      <button
                        key={device}
                        type="button"
                        onClick={() =>
                          setTargetDeviceTypes((prev) =>
                            prev.includes(device)
                              ? prev.filter((d) => d !== device)
                              : [...prev, device]
                          )
                        }
                        className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold border transition ${
                          targetDeviceTypes.includes(device)
                            ? "bg-[#ffff00] text-black border-[#ffff00]"
                            : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
                        }`}
                      >
                        {targetDeviceTypes.includes(device) && <FiCheck size={11} />}
                        {device}
                      </button>
                    ))}
                  </div>
                  <p className={`text-xs mt-1.5 ${targetDeviceTypes.length === 0 ? "text-red-400" : "text-gray-400"}`}>
                    {targetDeviceTypes.length === 0
                      ? "Select at least one device type"
                      : `Targeting: ${targetDeviceTypes.join(" & ")}`}
                  </p>
                </div>

                {/* Target Countries — searchable dropdown */}
                <div ref={countryRef}>
                  <label className="block text-xs font-medium text-gray-500 mb-1.5">
                    Target Countries <span className="text-gray-300">(optional — empty = all)</span>
                  </label>

                  {/* Selected tags + search input */}
                  <div
                    className={`flex flex-wrap gap-1.5 px-3 py-2 border rounded-lg min-h-[42px] cursor-text transition ${
                      countryDropdownOpen
                        ? "border-[#ffff00] ring-2 ring-[#ffff00]"
                        : "border-gray-200"
                    }`}
                    onClick={() => { setCountryDropdownOpen(true); }}
                  >
                    {targetCountries.map((code) => {
                      const country = COUNTRIES.find((c) => c.code === code);
                      return (
                        <span
                          key={code}
                          className="flex items-center gap-1 bg-[#ffffe0] text-[#999900] text-xs font-semibold px-2 py-0.5 rounded"
                        >
                          <span className="font-mono">{code}</span>
                          <span className="text-[#b8b800] font-normal hidden sm:inline">
                            {country ? ` ${country.name}` : ""}
                          </span>
                          <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); toggleCountry(code); }}
                            className="ml-0.5 hover:text-red-500 transition"
                          >
                            <FiX size={10} />
                          </button>
                        </span>
                      );
                    })}
                    <div className="flex items-center gap-1 flex-1 min-w-[120px]">
                      <input
                        value={countrySearch}
                        onChange={(e) => { setCountrySearch(e.target.value); setCountryDropdownOpen(true); }}
                        onFocus={() => setCountryDropdownOpen(true)}
                        placeholder={targetCountries.length === 0 ? "Search country..." : "Add more..."}
                        className="text-sm outline-none flex-1 bg-transparent"
                      />
                      <FiChevronDown
                        size={14}
                        className={`text-gray-400 flex-shrink-0 transition-transform ${countryDropdownOpen ? "rotate-180" : ""}`}
                      />
                    </div>
                  </div>

                  {/* Dropdown list */}
                  {countryDropdownOpen && (
                    <div className="absolute z-30 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-72 max-h-52 overflow-y-auto">
                      {filteredCountries.length === 0 ? (
                        <div className="px-4 py-3 text-xs text-gray-400 text-center">
                          {countrySearch ? "No countries match your search" : "All countries selected"}
                        </div>
                      ) : (
                        filteredCountries.map((c) => (
                          <button
                            key={c.code}
                            type="button"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => { toggleCountry(c.code); setCountrySearch(""); }}
                            className="w-full text-left px-3 py-2 text-sm hover:bg-[#ffffe0] flex items-center gap-2.5 transition"
                          >
                            <span className="font-mono text-xs text-gray-400 w-7 flex-shrink-0">{c.code}</span>
                            <span className="text-gray-700 flex-1">{c.name}</span>
                          </button>
                        ))
                      )}
                    </div>
                  )}

                  <p className="text-xs text-gray-400 mt-1.5">
                    {targetCountries.length === 0
                      ? "All countries will be targeted"
                      : `${targetCountries.length} countr${targetCountries.length === 1 ? "y" : "ies"} selected`}
                  </p>
                </div>
              </div>

              <div className="flex gap-3 pt-1">
                <button
                  onClick={handleCreateOrUpdate}
                  disabled={submitting}
                  className="flex items-center gap-2 bg-[#ffff00] hover:bg-[#e6e600] disabled:opacity-60 text-black text-sm font-medium px-5 py-2.5 rounded-lg transition"
                >
                  <FiPlus size={15} />
                  {submitting ? "Saving..." : editId ? "Update" : "Create"}
                </button>
                {editId && (
                  <button
                    onClick={handleCancel}
                    className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition"
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* List card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-sm font-semibold text-gray-700">All Notifications</h3>
              <span className="text-xs text-gray-400">Total: {total}</span>
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-16">
                <div className="w-8 h-8 border-4 border-[#ffff00] border-t-transparent rounded-full animate-spin" />
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-gray-50 text-left text-xs text-gray-400 uppercase tracking-wide">
                      <th className="px-5 py-3">#</th>
                      <th className="px-5 py-3 hidden sm:table-cell">Image</th>
                      <th className="px-5 py-3">Title</th>
                      <th className="px-5 py-3 hidden md:table-cell">Message</th>
                      <th className="px-5 py-3 hidden lg:table-cell">Redirect</th>
                      <th className="px-5 py-3 hidden lg:table-cell">Devices</th>
                      <th className="px-5 py-3 hidden xl:table-cell">Countries</th>
                      <th className="px-5 py-3 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {notifications.length === 0 ? (
                      <tr>
                        <td colSpan={8} className="text-center py-12 text-gray-400 text-sm">
                          No notifications yet. Create one above.
                        </td>
                      </tr>
                    ) : (
                      notifications.map((noti, index) => {
                        const imgSrc = noti.image || noti.imageUrl || null;
                        return (
                          <tr key={noti.id} className="hover:bg-gray-50 transition">
                            <td className="px-5 py-3.5 text-gray-400 text-xs">
                              {(page - 1) * limit + index + 1}
                            </td>
                            <td className="px-5 py-3.5 hidden sm:table-cell">
                              {imgSrc ? (
                                <img
                                  src={imgSrc}
                                  alt={noti.title}
                                  className="w-10 h-10 rounded-lg object-cover border border-gray-100"
                                />
                              ) : (
                                <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center">
                                  <FiBell size={14} className="text-gray-300" />
                                </div>
                              )}
                            </td>
                            <td className="px-5 py-3.5">
                              <p className="font-medium text-gray-800 line-clamp-1">{noti.title}</p>
                              <p className="text-xs text-gray-400 md:hidden line-clamp-1 mt-0.5">{noti.message}</p>
                            </td>
                            <td className="px-5 py-3.5 text-gray-500 hidden md:table-cell max-w-xs">
                              <p className="line-clamp-2">{noti.message}</p>
                            </td>
                            <td className="px-5 py-3.5 hidden lg:table-cell">
                              {noti.redirectRoute ? (
                                <span className="inline-block bg-[#ffffe0] text-[#b8b800] text-xs font-mono px-2 py-0.5 rounded">
                                  {noti.redirectRoute}
                                </span>
                              ) : (
                                <span className="text-gray-300 text-xs">—</span>
                              )}
                            </td>
                            <td className="px-5 py-3.5 hidden lg:table-cell">
                              {noti.targetDeviceTypes && noti.targetDeviceTypes.length > 0 ? (
                                <div className="flex flex-wrap gap-1">
                                  {noti.targetDeviceTypes.map((d) => (
                                    <span
                                      key={d}
                                      className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                                        d === "Android"
                                          ? "bg-green-50 text-green-600"
                                          : "bg-[#ffffe0] text-[#999900]"
                                      }`}
                                    >
                                      {d}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-xs text-gray-400">All</span>
                              )}
                            </td>
                            <td className="px-5 py-3.5 hidden xl:table-cell">
                              {noti.targetCountries && noti.targetCountries.length > 0 ? (
                                <div className="flex flex-wrap gap-1">
                                  {noti.targetCountries.slice(0, 3).map((code) => (
                                    <span
                                      key={code}
                                      className="text-xs font-mono font-medium bg-indigo-50 text-indigo-600 px-1.5 py-0.5 rounded"
                                    >
                                      {code}
                                    </span>
                                  ))}
                                  {noti.targetCountries.length > 3 && (
                                    <span className="text-xs text-gray-400 self-center">
                                      +{noti.targetCountries.length - 3}
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="text-xs text-gray-400">All</span>
                              )}
                            </td>
                            <td className="px-5 py-3.5">
                              <div className="flex items-center justify-center gap-1.5">
                                <button
                                  onClick={() => {
                                    setEditId(noti.id); setTitle(noti.title);
                                    setMessage(noti.message); setRedirectRoute(noti.redirectRoute || "");
                                    setImage(null); setImagePreview(null);
                                    setTargetDeviceTypes(noti.targetDeviceTypes || []);
                                    setTargetCountries(noti.targetCountries || []);
                                    if (imageInputRef.current) imageInputRef.current.value = "";
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                  }}
                                  className="p-1.5 rounded-lg text-indigo-500 hover:bg-indigo-50 transition"
                                  title="Edit"
                                >
                                  <FiEdit2 size={14} />
                                </button>
                                <button
                                  onClick={() => handleSend(noti.id)}
                                  disabled={sendingId === noti.id}
                                  className="p-1.5 rounded-lg text-green-500 hover:bg-green-50 disabled:opacity-50 transition"
                                  title="Send"
                                >
                                  {sendingId === noti.id ? (
                                    <div className="w-3.5 h-3.5 border-2 border-green-400 border-t-transparent rounded-full animate-spin" />
                                  ) : (
                                    <FiSend size={14} />
                                  )}
                                </button>
                                <button
                                  onClick={() => handleDelete(noti.id)}
                                  disabled={deletingId === noti.id}
                                  className="p-1.5 rounded-lg text-red-500 hover:bg-red-50 disabled:opacity-50 transition"
                                  title="Delete"
                                >
                                  {deletingId === noti.id ? (
                                    <div className="w-3.5 h-3.5 border-2 border-red-400 border-t-transparent rounded-full animate-spin" />
                                  ) : (
                                    <FiTrash2 size={14} />
                                  )}
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex flex-wrap items-center justify-center gap-2">
              <button
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                className="px-3 py-2 bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-40 text-sm"
              >
                &laquo;
              </button>
              {(() => {
                // Show a sliding window of 5 pages, plus the first/last page as jump targets
                const start = Math.max(1, Math.min(page - 2, totalPages - 4));
                const end = Math.min(totalPages, start + 4);
                const pageBtn = (pg) => (
                  <button
                    key={pg}
                    onClick={() => setPage(pg)}
                    className={`px-4 py-2 border rounded-lg text-sm transition ${
                      page === pg ? "bg-[#ffff00] text-black border-[#ffff00]" : "bg-white hover:bg-gray-50"
                    }`}
                  >
                    {pg}
                  </button>
                );
                const dots = (key) => (
                  <span key={key} className="px-1 text-sm text-gray-400 select-none">
                    &hellip;
                  </span>
                );
                return (
                  <>
                    {start > 1 && pageBtn(1)}
                    {start > 2 && dots("start-dots")}
                    {Array.from({ length: end - start + 1 }, (_, i) => start + i).map(pageBtn)}
                    {end < totalPages - 1 && dots("end-dots")}
                    {end < totalPages && pageBtn(totalPages)}
                  </>
                );
              })()}
              <button
                disabled={page === totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                className="px-3 py-2 bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-40 text-sm"
              >
                &raquo;
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default NotificationPage;
